import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import TipoGastoExtraGrid from './TipoGastoExtraGrid.jsx'
import TipoGastoExtraAbm from './TipoGastoExtraAbm.jsx'
import {FormattedMessage, injectIntl} from 'react-intl';

class TipoGastoExtra extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="tipoGastoExtra.label.administracion_tipos_gastos_extras" defaultMessage="Administración de Tipos de Gastos"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={TipoGastoExtraGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <TipoGastoExtraAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <TipoGastoExtraAbm {...props} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <TipoGastoExtraAbm {...props} action="VIEW" />} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default injectIntl(TipoGastoExtra);
